const GET_FOOTER_REQUEST = 'GET_FOOTER_REQUEST';
const GET_FOOTER_SUCCESS = 'GET_FOOTER_SUCCESS';
const GET_FOOTER_FAILURE = 'GET_FOOTER_FAILURE';

import * as backend from 'backend-helpers/footer';

const initState = null;

export default function footer(state = initState, action) {
    if (action.type === GET_FOOTER_SUCCESS) {
        return action.result.data;
    }

    return state;
}

export function getFooter() {
    return {
        types: [GET_FOOTER_REQUEST, GET_FOOTER_SUCCESS, GET_FOOTER_FAILURE],
        promise: backend.getFooter()
    }
}


// WEBPACK FOOTER //
// ./src/reducers/footer.js